// extracted by mini-css-extract-plugin
export default {"Stat":"styles_Stat__p3ikN","graph":"styles_graph__-pXpe","fill":"styles_fill__w1hS8"};